import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DownloadSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DownloadSVG;
